// Tier-2 <Tag> status pill backed by AntD Tag (FORT-182). The `tone` vocabulary
// is ours and maps to semantic token colours (not AntD's preset palette names),
// so pill colours track the design tokens. `processing` uses AntD's animated
// preset, which has no token equivalent.
import React from 'react';
import { Tag as AntTag } from 'antd';
import { useTokens } from '../../core/theme/TokensProvider';
import type { CommonProps } from './types';

export type TagTone = 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'processing';

export interface TagProps extends CommonProps {
  tone?: TagTone;
  children: React.ReactNode;
}

export const Tag: React.FC<TagProps> = ({
  tone = 'default',
  children,
  className,
  style,
  'data-testid': dataTestId,
}) => {
  const tokens = useTokens();
  const color =
    tone === 'default'
      ? undefined
      : tone === 'processing'
        ? 'processing'
        : tone === 'primary'
          ? tokens.color.primary
          : tokens.color[tone]; // success | warning | danger
  return (
    <AntTag color={color} className={className} style={style} data-testid={dataTestId}>
      {children}
    </AntTag>
  );
};
